import { makeStyles } from '@mui/styles'
import { getPixelInREM } from '../../common/material'

export const useCompoundsPageStyles = makeStyles((theme) => ({
    emptyState: {
        display: 'block',
        fontSize: getPixelInREM(16),
        marginTop: getPixelInREM(15),
        fontWeight: 500,
        color: theme.palette.grey[700]
    }
}))
